import api from './api';

const state = {
	plans: [],
};

const getters = { rotationPlanNames: (state) => state.plans.map((plan) => plan.name) };

const mutations = {
	setPlans(state, { plans }) {
		state.plans = plans;
	},
	setPlan(state, { plan }) {
		const index = state.plans
			.map((plan) => {
				return plan.id;
			})
			.indexOf(plan.id);

		let plans = state.plans;
		if (index > -1) {
			plans.splice(index, 1, plan);
		} else {
			plans.push(plan);
		}

		state.plans = plans;
	},
};

const actions = {
	async load({ state, commit, rootGetters, dispatch }) {
		return api
			.getPlans(true)
			.then(async (response) => {
				const plans = response.data;
				commit('setPlans', { plans });
			})
			.catch((err) => {
				const message = err?.response?.data?.message;
				console.error('Problems to get plans in rotation store: ', message);
			});
	},

	async loadForPlanningView({ commit }) {
		const plans = (await api.getPlans(false)).data;
		commit('setPlans', { plans });
	},

	async savePlan({ state, commit, rootGetters, dispatch }, { plan }) {
		if (plan) {
			if (plan.id) {
				if (plan.startDate === '') {
					delete plan.startDate;
				}
				//Update
				return api
					.updatePlan(plan.id, plan)
					.then(async (response) => {
						const plan = response.data;
						commit('setPlan', { plan });

						return response;
					})
					.catch((err) => {
						const message = err?.response?.data?.message;
						console.error('Problems to save plan in rotation store: ', message);

						// Return the error response so the component can handle it
						return err.response || err;
					});
			} else {
				if (!plan.startDate) {
					plan.startDate = new Date().toISOString().split('T')[0];
				}
				//Create
				return api
					.createPlan(plan)
					.then(async (response) => {
						const plan = response.data;
						commit('setPlan', { plan });

						return response;
					})
					.catch((err) => {
						const message = err?.response?.data?.message;
						console.error('Problems to save plan in rotation store: ', message);

						// Return the error response so the component can handle it
						return err.response || err;
					});
			}
		} else {
			console.error('No plan data provided to save');
		}
	},

	async deletePlan({ state, commit, rootGetters, dispatch }, { planId }) {
		if (planId) {
			return api
				.deletePlan(planId)
				.then(async (response) => {
					if (response.status > 199 && response.status < 300) {
						commit('setPlan', { plan: { id: planId, deleted: true } });

						return { id: planId, response: response };
					}
				})
				.catch((err) => {
					const message = err?.response?.data?.message;
					console.error('Problems to save plan in rotation store: ', message);

					return err;
				});
		} else {
			console.error('No plan id provided to delete');
		}
	},

	async restorePlan({ state, commit, rootGetters, dispatch }, { planId, plan }) {
		if (planId) {
			return api
				.updatePlan(planId, { ...plan, deleted: false })
				.then(async (response) => {
					const plan = response.data;
					commit('setPlan', { plan });

					return response;
				})
				.catch((err) => {
					const message = err?.response?.data?.message;
					console.error('Problems to restore plan in rotation store: ', message);

					return err;
				});
		} else {
			console.error('No plan id provided to restore');
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
